import useSWR from 'swr';

import axios, { endpoints, fetcher } from '@/utils/axios';

export type ReferralInviter = {
  referrerName: string | null;
  referrerAvatarUrl: string | null;
};

export type PlatformFeeQuote = {
  baseFeeBps: number;
  discountBps: number;
  effectiveFeeBps: number;
  activeDiscountBpsTotal: number;
  activeDiscountCount: number;
};

export type ReferralMeResponse = {
  ok: boolean;
  code: string;
  link: string;
  platformFee: PlatformFeeQuote;
};

export type ReferralRow = {
  id: string;
  referrerId: string;
  referredUserId: string;
  status: 'CLAIMED' | 'PUBLISHED' | 'FIRST_SALE';
  source: 'LINK' | 'MANUAL_CODE' | 'IMPORT';
  claimedAt: string;
  publishedAt: string | null;
  firstSaleAt: string | null;
  referredUser: { id: string; name: string | null; avatarUrl?: string | null } | null;
};

export async function lookupReferralInviter(code: string): Promise<ReferralInviter> {
  const res = await axios.get(endpoints.referral, { params: { endpoint: 'lookup', code } });
  return res.data?.inviter as ReferralInviter;
}

export async function claimReferral(code: string): Promise<any> {
  const res = await axios.post(endpoints.referral, { code }, { params: { endpoint: 'claim' } });
  return res.data;
}

export function useReferralMe() {
  const url: any = [endpoints.referral, { params: { endpoint: 'me' } }];
  const { data, error, isLoading, mutate } = useSWR<ReferralMeResponse>(url, fetcher);
  return { data, error, isLoading, refresh: mutate };
}

export function useReferralList() {
  const url: any = [endpoints.referral, { params: { endpoint: 'list' } }];
  const { data, error, isLoading, mutate } = useSWR<{ ok: boolean; referrals: ReferralRow[]; summary: any }>(url, fetcher);
  return { data, error, isLoading, refresh: mutate };
}
